import { CardActionArea, CardMedia, useTheme } from "@mui/material";
import React from "react";

import { Card } from "../Card2";
import { ImageGrid } from "../ImageGrid/ImageGrid";
import type { ModelCardModel } from "./ModelCard";

interface ModelCardGroupProps<M extends ModelCardModel = ModelCardModel> {
  models: M[];
  onClickCard: (event: React.MouseEvent, models: M[]) => void;
}

const getModelThumbnail = (model: ModelCardModel) => {
  return (
    model.featuredFiles?.[0]?.file?.thumbnails?.large?.url ||
    model.featuredFiles?.[0]?.file?.thumbnails?.medium?.url ||
    model.featuredFiles?.[0]?.file?.url ||
    ""
  );
};

export const ModelCardGroup = <M extends ModelCardModel = ModelCardModel>(
  props: ModelCardGroupProps<M>,
) => {
  const { models, onClickCard } = props;

  const theme = useTheme();

  const thumbnails = models.map(getModelThumbnail);

  return (
    <Card
      sx={{
        containerType: "inline-size",
      }}
    >
      <CardActionArea onClick={(e) => onClickCard(e, models)}>
        <CardMedia>
          <ImageGrid
            imageSrcs={thumbnails}
            rows={3}
            columns={3}
            sx={{ gap: 2, padding: 2 }}
            slotProps={{
              placeholder: {
                sx: {
                  color: theme.palette.secondary[5],
                },
              },
            }}
          />
        </CardMedia>
      </CardActionArea>
    </Card>
  );
};
